const correspondenciaRoutes = [
  // Boleto
  {
    path: '/correspondencias',
    name: 'correspondencia-list',
    component: () => import('@/views/correspondencia/CorrespondenciaDashboard.vue'),
    meta: {
      resource: 'Auth',
      action: 'read',
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Correspondências', active: true },
      ],
    },
  },
  {
    path: '/correspondencia/:id',
    name: 'correspondencia-view',
    component: () => import('@/views/correspondencia/CorrespondenciaView.vue'),
    meta: {
      resource: 'Auth',
      action: 'read',
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Correspondências', url: '/correspondencias' },
        { title: 'Visualizar', active: true },
      ],
    },
  },
]

export default correspondenciaRoutes
